import { Dialog, styled } from '@material-ui/core';

const DialogStyled = styled(Dialog)({
  '& .MuiDialog-paperFullWidth': {
    borderRadius: '0.75rem',
    padding: '1rem'
  }
});

const FormDialog = ({ children, ...rest }) => <DialogStyled {...rest}>{children}</DialogStyled>;

export default FormDialog;
